import React, { useState, useEffect } from 'react'
import { useKhlxrListQuery } from '../../store/DianShangYeWuApi';
import classes from './client.module.css';  
import { Flex, Table } from 'antd';
import ClientContactAdd from './ClientContactAdd';
import ClientContactEdit from './ClientContactEdit';
function ClientContactList(props) {
    const [contactInfo, setContactInfo] = useState([])
    //客户对接人
    const { data: contactData, isSuccess: contactSuccess } = useKhlxrListQuery({ khlxr_kh_id: props.kh_id }, { skip: !props.kh_id, refetchOnMountOrArgChange: 1 })
    useEffect(() => {
        if (contactSuccess) {
            setContactInfo(contactData.Result)
        }
    }, [contactData, contactSuccess])
    const columnsContact = [
        {
            key:'khlxr_name',
            title:'部门名称',
            dataIndex:'khlxr_name',
            render:(text,record) => {
                return <ClientContactEdit 
                            khlxr_id={record.khlxr_id} 
                            khlxr_name={record.khlxr_name} 
                            khlxr_phone={record.khlxr_phone} 
                            khlxr_content={record.khlxr_content} 
                            kh_id={props.kh_id} 
                            kh_name={props.kh_name} 
                            yh_id={props.yh_id} 
                            yh_name={props.yh_name} 
                            qy_id={props.qy_id} 
                            qy_name={props.qy_name} 
                            khlxr_ctime={record.khlxr_ctime}
                            khlxr_update_time={record.khlxr_update_time}
                            khlxr_uname={record.khlxr_uname}
                            khlxr_update_uname={record.khlxr_update_uname}
                        />
            }
        },
        {
            key:'khlxr_phone',
            title:'电话',
            dataIndex:'khlxr_phone'
        },
        {
            key:'khlxr_content',
            title:'备注',
            dataIndex:'khlxr_content'
        },      
    ]
    return (
        <>
            <Flex justify='space-between' align='center' style={{width:'1000px',marginTop:'10px'}}>
                <div style={{fontSize:'16px',fontWeight:'bold',marginTop:'10px',color:'#003366'}}>部门</div>
                <ClientContactAdd 
                    kh_id={props.kh_id} 
                    kh_name={props.kh_name} 
                    yh_id={props.yh_id} 
                    yh_name={props.yh_name} 
                    qy_id={props.qy_id} 
                    qy_name={props.qy_name} 
                />
            </Flex>
            <Table 
                dataSource={contactInfo} 
                columns={columnsContact} 
                className={classes.contactTable}
                size='small'
                bordered
                pagination={false}
                rowKey='khlxr_id'
                style={{marginTop:'2px',width:'1000px'}}
                locale={{
                    emptyText: '暂无对接人' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default ClientContactList